/*
 * @Author: xujialei01 jialei@tataufo.com
 * @Date: 2022-11-16 16:07:57
 * @LastEditors: xujialei01 jialei@tataufo.com
 * @LastEditTime: 2023-03-17 17:32:53
 * @FilePath: /project/maro_connect/connect/src/main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'normalize.css'
import VueI18n from 'vue-i18n'
// import CN from './i18n/cn'
import EN from './i18n/en'
import KR from './i18n/kr'
import ID from './i18n/id'
import VI from './i18n/vi'

Vue.config.productionTip = false

Vue.use(VueI18n)

// 获取本地语言
// const supportLanguage = ['en', 'ko', 'zh', 'id', 'vi']
const supportLanguage = ['en', 'ko', 'id', 'vi']

const lang = navigator.language || navigator.userLanguage // 常规浏览器语言和IE浏览器;
let DEFAULT_LANG = lang.substr(0, 2)
if (supportLanguage.indexOf(DEFAULT_LANG) <= -1) {
  DEFAULT_LANG = 'en'
}
const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: {
    en: EN,
    ko: KR,
    // zh: CN,
    id: ID,
    vi: VI
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js